/**
 * SPR Naturals — one-time section entrance reveal.
 *
 * Deliberately minimal: no dependencies, no framework, ~30 lines.
 * Reveals each top-level section once as it scrolls into view; sections
 * already visible on load are shown immediately with no animation, so
 * above-the-fold content (the hero) never "pops in." Fully skipped under
 * prefers-reduced-motion — no .spr-reveal class is ever applied, so
 * content is simply visible with no JS-driven state at all.
 *
 * Entry-sequence exception: the heritage marquee bridge and trust strip
 * both sit right at the ~85% above-fold boundary used below, which made
 * their motion handoff from the hero video inconsistent (sometimes
 * animated, sometimes not, depending on exact viewport height) rather
 * than a deliberate part of the entry sequence. Both are always given
 * the reveal treatment regardless of that boundary, so the video's
 * motion always continues into a settling animation instead of an
 * unpredictable hard stop.
 *
 * See assets/spr-custom.css for the paired transition rules and
 * docs/DESIGN.md (Animation Philosophy) for the reasoning.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('#MainContent > .shopify-section');
  if (!sections.length) return;

  var ALWAYS_REVEAL = ['shopify-section-marquee_hero_bridge', 'shopify-section-trust_strip'];

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('spr-reveal--visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  sections.forEach(function (section) {
    // Launch fix: never hide product grids or prices behind the reveal —
    // on slow phones they should be readable the moment they arrive.
    if (section.querySelector('product-card, .product-card, .product-grid, .price')) return;
    var isEntrySequence = ALWAYS_REVEAL.indexOf(section.id) !== -1;
    var isAboveFold = section.getBoundingClientRect().top < window.innerHeight * 0.85;
    if (isAboveFold && !isEntrySequence) return;
    section.classList.add('spr-reveal');
    observer.observe(section);
  });
})();
